// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c89e917e","732":"bb3af5b1","977":"67b73f77"}[chunkId] + ".chunk.js";
};